import { createPortal } from 'react-dom';
import { classNames } from '../../helper/classNames';
import CloseButton from '../CloseButton';
import Overlay from '../Overlay';

export type ModalProps = {
  close: (
    event?:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.MouseEvent<HTMLDivElement>
  ) => void;
  closeOnClickOutside?: boolean;
  show: boolean;
};

type Props = ModalProps & {
  children: React.ReactNode;
};

const Modal = ({
  children,
  close,
  closeOnClickOutside = true,
  show,
}: Props) => {
  const handleClickOutside = () => {
    if (closeOnClickOutside) {
      close();
    }
  };
  return (
    <>
      {createPortal(
        <>
          <Overlay isOpen={show} className="z-50" />
          <div
            className={classNames(
              'absolute inset-0 z-50 flex h-full place-content-center items-center justify-center',
              !show && 'pointer-events-none'
            )}
          >
            <div
              className="absolute inset-0 h-full w-full opacity-0"
              onClick={handleClickOutside}
            />
            <div
              className={classNames(
                // display:flex prevents child overflowing while adjusting its height to fit its content, without it the child either overflows or always has the same height as its parent regardless of the content height
                'relative flex max-h-[90%] max-w-[90%] transition-all duration-500',
                show
                  ? 'scale-1 opacity-100 ease-[cubic-bezier(0.9,1,0.5,1.5)]'
                  : 'scale-0 opacity-0 ease-[cubic-bezier(0.5,-0.5,0.1,1)]'
              )}
            >
              <div className="background overflow-y-auto rounded-xl p-5">
                <div>{children}</div>
              </div>
              <CloseButton
                className="absolute right-0 top-0 -translate-y-1/2 translate-x-1/2"
                onClick={close}
              />
            </div>
          </div>
        </>,
        document.body
      )}
    </>
  );
};

export default Modal;
